(function () {
  var DESKTOP_MQ = '(min-width: 990px)';

  var NEXT_ICON =
    '<span class="prize-gallery__thumb-more prize-gallery__thumb-more--next" aria-hidden="true">' +
    '<svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M32.5303 6.05328C32.8232 5.76039 32.8232 5.28551 32.5303 4.99262L27.7574 0.219648C27.4645 -0.073245 26.9896 -0.073245 26.6967 0.219648C26.4038 0.512542 26.4038 0.987415 26.6967 1.28031L30.9393 5.52295L26.6967 9.76559C26.4038 10.0585 26.4038 10.5334 26.6967 10.8263C26.9896 11.1191 27.4645 11.1191 27.7574 10.8263L32.5303 6.05328ZM0 5.52295V6.27295H32V5.52295V4.77295H0V5.52295Z" fill="#F6F0E3"/>' +
    '</svg>' +
    '</span>';

  var PREV_ICON =
    '<span class="prize-gallery__thumb-more prize-gallery__thumb-more--prev" aria-hidden="true">' +
    '<svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0.219669 4.99262C-0.0732231 5.28552 -0.0732231 5.76039 0.219669 6.05328L4.99264 10.8263C5.28553 11.1191 5.76041 11.1191 6.0533 10.8263C6.34619 10.5334 6.34619 10.0585 6.0533 9.76559L1.81066 5.52295L6.0533 1.28031C6.34619 0.987418 6.34619 0.512544 6.0533 0.219651C5.76041 -0.0732427 5.28553 -0.0732426 4.99264 0.219651L0.219669 4.99262ZM32.75 5.52295L32.75 4.77295L0.75 4.77295L0.75 5.52295L0.75 6.27295L32.75 6.27295L32.75 5.52295Z" fill="#F6F0E3"/>' +
    '</svg>' +
    '</span>';

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function buildThumbs(root) {
    var mainEl = root.querySelector('[data-prize-gallery-main]');
    var thumbsWrapper = root.querySelector('[data-prize-gallery-thumbs-wrapper]');
    if (!mainEl || !thumbsWrapper || thumbsWrapper.children.length > 0) return;

    var mainImages = mainEl.querySelectorAll('.swiper-slide img');
    mainImages.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide prize-gallery__thumb';

      var thumbImg = document.createElement('img');
      thumbImg.src = img.currentSrc || img.getAttribute('src');
      thumbImg.alt = img.getAttribute('alt') || '';
      thumbImg.loading = 'lazy';

      slide.appendChild(thumbImg);
      slide.insertAdjacentHTML('beforeend', PREV_ICON + NEXT_ICON);
      thumbsWrapper.appendChild(slide);
    });
  }

  function updateMoreOverlay(swiper) {
    if (!swiper || !swiper.slides) return;

    Array.prototype.forEach.call(swiper.slides, function (slide) {
      slide.classList.remove('prize-gallery__thumb--more-prev', 'prize-gallery__thumb--more-next');
    });

    if (!isDesktop()) return;

    var perView = swiper.params.slidesPerView;
    var visibleCount =
      perView === 'auto'
        ? (swiper.visibleSlides && swiper.visibleSlides.length) || 0
        : Math.floor(perView);

    if (!visibleCount || swiper.slides.length <= visibleCount) return;

    var firstVisibleIndex = swiper.activeIndex;
    var lastVisibleIndex = Math.min(firstVisibleIndex + visibleCount - 1, swiper.slides.length - 1);

    if (firstVisibleIndex > 0) {
      swiper.slides[firstVisibleIndex].classList.add('prize-gallery__thumb--more-prev');
    }

    if (lastVisibleIndex < swiper.slides.length - 1) {
      swiper.slides[lastVisibleIndex].classList.add('prize-gallery__thumb--more-next');
    }
  }

  function initGallery(root) {
    if (root.dataset.swiperInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var mainEl = root.querySelector('[data-prize-gallery-main]');
    var thumbsEl = root.querySelector('[data-prize-gallery-thumbs]');

    if (!mainEl) return;

    if (thumbsEl) {
      buildThumbs(root);
    }

    var thumbsSwiper = null;

    if (thumbsEl) {
      var thumbCount = thumbsEl.querySelectorAll('.swiper-slide').length;
      var desktopSlides = Math.min(6, Math.max(1, thumbCount));

      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        watchOverflow: true,
        freeMode: true,
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true
          },
          990: {
            slidesPerView: desktopSlides,
            spaceBetween: 12,
            freeMode: false
          }
        },
        on: {
          init: function (swiper) {
            requestAnimationFrame(function () {
              updateMoreOverlay(swiper);
            });
          },
          slideChange: updateMoreOverlay,
          progress: updateMoreOverlay,
          breakpoint: updateMoreOverlay,
          resize: updateMoreOverlay
        }
      });

      thumbsEl.addEventListener(
        'click',
        function (event) {
          var prevThumb = event.target.closest('.prize-gallery__thumb--more-prev');
          var nextThumb = event.target.closest('.prize-gallery__thumb--more-next');
          if (!prevThumb && !nextThumb) return;
          event.preventDefault();
          event.stopPropagation();
          if (prevThumb) {
            thumbsSwiper.slidePrev();
          } else {
            thumbsSwiper.slideNext();
          }
        },
        true
      );
    }

    var mainSwiper = new Swiper(mainEl, {
      spaceBetween: 0,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
    });

    root.dataset.swiperInitialized = 'true';
    root._swiperInstances = { main: mainSwiper, thumbs: thumbsSwiper };
  }

  function destroyGallery(root) {
    if (root._swiperInstances) {
      if (root._swiperInstances.main) root._swiperInstances.main.destroy(true, true);
      if (root._swiperInstances.thumbs) root._swiperInstances.thumbs.destroy(true, true);
      root._swiperInstances = null;
    }
    var thumbsWrapper = root.querySelector('[data-prize-gallery-thumbs-wrapper]');
    if (thumbsWrapper) thumbsWrapper.innerHTML = '';
    delete root.dataset.swiperInitialized;
  }

  function refreshGallery(root, options) {
    if (!root || !root._swiperInstances) return;
    var resetToFirst = options && options.resetToFirst;

    function sync() {
      if (!root._swiperInstances) return;
      var main = root._swiperInstances.main;
      var thumbs = root._swiperInstances.thumbs;
      if (main) {
        main.update();
        if (resetToFirst) main.slideTo(0, 0);
      }
      if (thumbs) {
        thumbs.update();
        if (resetToFirst) thumbs.slideTo(0, 0);
        // Ensure first thumb is marked active after gallery was shown from [hidden]
        if (resetToFirst && thumbs.slides && thumbs.slides.length) {
          Array.prototype.forEach.call(thumbs.slides, function (slide, index) {
            slide.classList.toggle('swiper-slide-thumb-active', index === 0);
          });
        }
        updateMoreOverlay(thumbs);
      }
    }

    requestAnimationFrame(function () {
      sync();
      // Second frame: layout is correct after removing [hidden]
      requestAnimationFrame(sync);
    });
  }

  function accordionImageGroup(details) {
    if (!details) return null;
    return details.querySelector('.details-content .group-block:has(.image-block)');
  }

  function accordionImages(details) {
    var group = accordionImageGroup(details);
    if (!group) return [];
    return Array.prototype.slice.call(group.querySelectorAll('.image-block__image'));
  }

  function createGalleryFromImages(images, key) {
    var root = document.createElement('div');
    root.className = 'prize-details__gallery prize-gallery';
    root.setAttribute('data-prize-gallery', '');
    root.dataset.prizeGalleryKey = key;
    root.hidden = true;

    var main = document.createElement('div');
    main.className = 'swiper prize-gallery__main';
    main.setAttribute('data-prize-gallery-main', '');

    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach(function (img, index) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide prize-gallery__slide';

      var clone = document.createElement('img');
      clone.className = 'prize-details__image';
      clone.src = largestImageSrc(img);
      clone.alt = img.getAttribute('alt') || '';
      clone.decoding = 'async';
      clone.loading = index === 0 ? 'eager' : 'lazy';

      slide.appendChild(clone);
      wrapper.appendChild(slide);
    });

    main.appendChild(wrapper);
    root.appendChild(main);

    if (images.length > 1) {
      var thumbs = document.createElement('div');
      thumbs.className = 'swiper prize-gallery__thumbs';
      thumbs.setAttribute('data-prize-gallery-thumbs', '');
      thumbs.innerHTML = '<div class="swiper-wrapper" data-prize-gallery-thumbs-wrapper></div>';
      root.appendChild(thumbs);
    }

    return root;
  }

  function showGallery(section, key) {
    var galleries = section.querySelectorAll('[data-prize-gallery]');
    var match = null;
    var previousKey = null;

    galleries.forEach(function (gallery) {
      var galleryKey = gallery.dataset.prizeGalleryKey || 'default';
      var isMatch = galleryKey === key;
      if (!gallery.hidden && !isMatch) previousKey = galleryKey;
      gallery.hidden = !isMatch;
      if (isMatch) match = gallery;
    });

    if (match) {
      // Gallery was often init'd while [hidden]; reset to first slide so the
      // first thumbnail gets swiper-slide-thumb-active when switching accordions.
      refreshGallery(match, { resetToFirst: previousKey !== key });
    }
  }

  function syncGallery(section, details) {
    if (!isDesktop()) {
      showGallery(section, 'default');
      return;
    }

    var key = 'default';
    if (details && details.open && accordionImages(details).length) {
      key = details.dataset.prizeGalleryKey || 'default';
    }

    showGallery(section, key);
  }

  function buildSyncedGalleries(section) {
    var media = section.querySelector('.prize-details__media');
    var defaultGallery = section.querySelector('[data-prize-gallery-key="default"]');
    if (!media || !defaultGallery) return;

    var caption = media.querySelector('.prize-details__caption');

    section.querySelectorAll('.prize-details__content details.accordion-row-details').forEach(function (details, index) {
      var images = accordionImages(details);
      if (!images.length) return;

      var key = 'accordion-' + index;
      details.dataset.prizeGalleryKey = key;

      var existing = section.querySelector(
        '[data-prize-gallery][data-prize-gallery-key="' + key + '"]'
      );
      if (existing) return;

      var gallery = createGalleryFromImages(images, key);
      media.insertBefore(gallery, caption || defaultGallery.nextSibling);
      initGallery(gallery);
    });
  }

  function initInlineCarousel(group) {
    if (group.dataset.inlineCarousel === 'true') return;
    if (typeof Swiper === 'undefined') return;
    if (isDesktop()) return;

    var row = group.querySelector('.layout-panel-flex--row') || group;
    var items = Array.prototype.filter.call(row.children, function (child) {
      return child.querySelector && child.querySelector('.image-block, .image-block__image, img');
    });
    if (items.length < 2) return;

    var swiperEl = document.createElement('div');
    swiperEl.className = 'swiper prize-inline-carousel';
    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    items.forEach(function (item) {
      var slide = document.createElement('div');
      slide.className = 'swiper-slide prize-inline-carousel__slide';
      slide.appendChild(item);
      wrapper.appendChild(slide);
    });

    swiperEl.appendChild(wrapper);

    var paginationEl = null;
    if (items.length > 1) {
      paginationEl = document.createElement('div');
      paginationEl.className = 'swiper-pagination prize-inline-carousel__pagination';
      swiperEl.appendChild(paginationEl);
    }

    row.appendChild(swiperEl);
    group.dataset.inlineCarousel = 'true';

    group._inlineSwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      autoHeight: false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : undefined
    });
  }

  function destroyInlineCarousel(group) {
    if (group._inlineSwiper) {
      group._inlineSwiper.destroy(true, true);
      group._inlineSwiper = null;
    }

    var swiperEl = group.querySelector('.prize-inline-carousel');
    var row = group.querySelector('.layout-panel-flex--row') || group;
    if (swiperEl) {
      swiperEl.querySelectorAll('.prize-inline-carousel__slide').forEach(function (slide) {
        while (slide.firstChild) row.appendChild(slide.firstChild);
      });
      swiperEl.remove();
    }

    delete group.dataset.inlineCarousel;
  }

  function initInlineCarousels(section) {
    section.querySelectorAll('.prize-details__content details.accordion-row-details .group-block:has(.image-block)').forEach(initInlineCarousel);
  }

  function destroyInlineCarousels(section) {
    section.querySelectorAll('.prize-details__content .group-block[data-inline-carousel="true"]').forEach(destroyInlineCarousel);
  }

  function refreshInlineCarousel(details) {
    var group = accordionImageGroup(details);
    if (!group || !group._inlineSwiper) return;
    group._inlineSwiper.update();
    requestAnimationFrame(function () {
      if (group._inlineSwiper) group._inlineSwiper.update();
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function accordionDurationMs() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--animation-speed-slow').trim();
    var seconds = parseFloat(raw);
    if (!seconds) return 400;
    return Math.round(Math.max(320, seconds * 2000));
  }

  function accordionEasing() {
    return getComputedStyle(document.documentElement).getPropertyValue('--animation-easing').trim() || 'ease';
  }

  function clearAccordionInlineStyles(content) {
    if (!content) return;
    content.style.height = '';
    content.style.blockSize = '';
    content.style.opacity = '';
    content.style.overflow = '';
    content.style.transition = '';
  }

  function cancelAccordionAnimation(content) {
    if (!content || !content._accordionCleanup) return;
    content._accordionCleanup();
    content._accordionCleanup = null;
  }

  function measureAccordionHeight(content, details) {
    if (!content) return 0;
    var previous = {
      height: content.style.height,
      blockSize: content.style.blockSize,
      overflow: content.style.overflow,
      opacity: content.style.opacity,
      transition: content.style.transition
    };
    content.style.transition = 'none';
    content.style.overflow = 'hidden';
    content.style.height = 'auto';
    content.style.blockSize = 'auto';
    content.style.opacity = '1';
    refreshInlineCarousel(details);
    var height = content.scrollHeight;
    content.style.height = previous.height;
    content.style.blockSize = previous.blockSize;
    content.style.overflow = previous.overflow;
    content.style.opacity = previous.opacity;
    content.style.transition = previous.transition;
    return height;
  }

  function animateAccordionContent(content, open, done) {
    if (!content) {
      if (done) done();
      return;
    }

    cancelAccordionAnimation(content);

    if (prefersReducedMotion()) {
      if (open) {
        clearAccordionInlineStyles(content);
      } else {
        content.style.transition = 'none';
        content.style.overflow = 'hidden';
        content.style.height = '0px';
        content.style.blockSize = '0px';
        content.style.opacity = '0';
      }
      if (done) done();
      return;
    }

    var duration = accordionDurationMs();
    var easing = accordionEasing();
    var details = content.closest('details');
    var from = open ? 0 : content.getBoundingClientRect().height || content.scrollHeight;
    var to = open ? measureAccordionHeight(content, details) : 0;

    content.style.transition = 'none';
    content.style.overflow = 'hidden';
    content.style.height = from + 'px';
    content.style.blockSize = from + 'px';
    content.style.opacity = open ? '0' : '1';
    content.getBoundingClientRect();

    var finished = false;
    var timeoutId = 0;

    function complete(event) {
      if (finished) return;
      if (event && event.propertyName && event.propertyName !== 'height' && event.propertyName !== 'block-size') {
        return;
      }
      finished = true;
      content.removeEventListener('transitionend', complete);
      window.clearTimeout(timeoutId);
      content._accordionCleanup = null;
      if (open) {
        clearAccordionInlineStyles(content);
      } else {
        content.style.transition = 'none';
        content.style.overflow = 'hidden';
        content.style.height = '0px';
        content.style.blockSize = '0px';
        content.style.opacity = '0';
      }
      if (done) done();
    }

    content._accordionCleanup = function () {
      finished = true;
      content.removeEventListener('transitionend', complete);
      window.clearTimeout(timeoutId);
    };

    requestAnimationFrame(function () {
      if (finished) return;
      content.style.transition =
        'height ' + duration + 'ms ' + easing + ', block-size ' + duration + 'ms ' + easing + ', opacity ' + Math.round(duration * 0.75) + 'ms ' + easing;
      content.style.height = to + 'px';
      content.style.blockSize = to + 'px';
      content.style.opacity = open ? '1' : '0';
      content.addEventListener('transitionend', complete);
      timeoutId = window.setTimeout(complete, duration + 80);
    });
  }

  function closeAccordion(details, done) {
    if (!details.open) {
      if (done) done();
      return;
    }
    if (details.dataset.accordionAnimating === 'close') {
      if (done) done();
      return;
    }

    details.dataset.accordionAnimating = 'close';
    animateAccordionContent(details.querySelector('.details-content'), false, function () {
      details.open = false;
      var content = details.querySelector('.details-content');
      clearAccordionInlineStyles(content);
      delete details.dataset.accordionAnimating;
      if (done) done();
    });
  }

  function openAccordion(details) {
    if (details.dataset.accordionAnimating === 'open') return;
    if (details.open && details.dataset.accordionAnimating !== 'close') return;

    details.dataset.accordionAnimating = 'open';
    var content = details.querySelector('.details-content');
    if (content) {
      content.style.transition = 'none';
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.style.blockSize = '0px';
      content.style.opacity = '0';
    }
    details.open = true;
    if (content) {
      content.style.height = '0px';
      content.style.blockSize = '0px';
      content.style.opacity = '0';
    }
    animateAccordionContent(content, true, function () {
      delete details.dataset.accordionAnimating;
      if (!isDesktop()) refreshInlineCarousel(details);
    });
  }

  function initAccordionSync(section) {
    if (section.dataset.prizeAccordionSync === 'true') return;
    section.dataset.prizeAccordionSync = 'true';

    var detailsList = section.querySelectorAll('.prize-details__content details.accordion-row-details');

    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (details.dataset.accordionAnimating === 'open') {
            closeAccordion(details);
            return;
          }

          if (details.open && details.dataset.accordionAnimating !== 'close') {
            closeAccordion(details);
            return;
          }

          detailsList.forEach(function (other) {
            if (other !== details && (other.open || other.dataset.accordionAnimating === 'open')) {
              closeAccordion(other);
            }
          });
          openAccordion(details);
        });
      }

      details.addEventListener('toggle', function () {
        var active = section.querySelector('.prize-details__content details.accordion-row-details[open]');
        syncGallery(section, active);
        if (active && !isDesktop()) refreshInlineCarousel(active);
      });
    });

    var openDetails = section.querySelector('.prize-details__content details.accordion-row-details[open]');
    syncGallery(section, openDetails);
  }

  function initSection(section) {
    if (!section) return;

    section.querySelectorAll('[data-prize-gallery]').forEach(initGallery);
    buildSyncedGalleries(section);

    if (isDesktop()) {
      destroyInlineCarousels(section);
    } else {
      showGallery(section, 'default');
      initInlineCarousels(section);
    }

    initAccordionSync(section);
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('.prize-details-section').forEach(initSection);
  }

  function largestImageSrc(img) {
    var current = img.currentSrc || img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset');
    if (!srcset) return current;

    var best = current;
    var bestWidth = 0;
    srcset.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var url = bits[0];
      if (!url) return;
      var descriptor = bits[1] || '';
      var width = parseInt(descriptor, 10);
      if (!width) {
        var match = url.match(/[?&]width=(\d+)/);
        width = match ? parseInt(match[1], 10) : 0;
      }
      if (width >= bestWidth) {
        bestWidth = width;
        best = url;
      }
    });
    return best || current;
  }

  var desktopMq = window.matchMedia(DESKTOP_MQ);
  function handleBreakpointChange() {
    document.querySelectorAll('.prize-details-section').forEach(function (section) {
      var openDetails = section.querySelector('.prize-details__content details.accordion-row-details[open]');
      if (desktopMq.matches) {
        destroyInlineCarousels(section);
        syncGallery(section, openDetails);
      } else {
        showGallery(section, 'default');
        initInlineCarousels(section);
      }
    });
  }

  if (typeof desktopMq.addEventListener === 'function') {
    desktopMq.addEventListener('change', handleBreakpointChange);
  } else if (typeof desktopMq.addListener === 'function') {
    desktopMq.addListener(handleBreakpointChange);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-prize-gallery]').forEach(destroyGallery);
    event.target.querySelectorAll('.prize-details__content .group-block[data-inline-carousel="true"]').forEach(destroyInlineCarousel);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target.closest && event.target.closest('.prize-details-section details.accordion-row-details');
    if (!details) return;
    details.open = true;
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }
})();
